module.exports = __webpack_public_path__ + "img/HPlogo-light-XL.ddb72977.svg";